"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var React = require("react");
var rxjs_1 = require("rxjs");
var validDataUrl = require("valid-data-url");
var js_base64_1 = require("js-base64");
/**
 * Node is a rectangle within a Kaavio diagram.
 * It can be mapped to other pathway elements. For example, in PVJS this is mapped to metabolites and proteins.
 */
var Node = (function (_super) {
    __extends(Node, _super);
    function Node(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loadedIcon: null,
            iconSuffix: new Date().toISOString().replace(/\W/g, '')
        };
        return _this;
    }
    Node.prototype.componentDidMount = function () {
        this.getIcon();
    };
    Node.prototype.componentWilUpdate = function () {
        this.getIcon();
    };
    /**
     * Using the icon prop, get the required SVG and set the state.
     */
    Node.prototype.getIcon = function () {
        var _this = this;
        // Anders: The node now only receives one icon and is responsible for retrieving the data from it's url.
        // This makes sense here but do other components need to do this? In which case this should be in Entity
        // Could you also check the ajax request? Not sure if it's correct
        var icon = this.props.icon;
        if (!icon)
            return;
        if (validDataUrl(icon.url)) {
            var parts = icon.url.match(validDataUrl.regex);
            var mediaType = parts[1] ? parts[1].toLowerCase() : null;
            var charset = parts[2] ? parts[2].split('=')[1].toLowerCase : null;
            var isBase64 = !!parts[3];
            var data = parts[4] ? parts[4] : null;
            var svgString = !isBase64 ? decodeURIComponent(data) : js_base64_1.Base64.decode(data);
            this.setState({
                loadedIcon: {
                    id: icon.id,
                    svgString: svgString
                }
            });
        }
        else {
            var ajaxRequest = {
                url: icon.url,
                method: 'GET',
                responseType: 'text',
                timeout: 1 * 1000,
                crossDomain: true,
            };
            rxjs_1.Observable.ajax(ajaxRequest)
                .subscribe(function (ajaxResponse) {
                var svgString = ajaxResponse.xhr.response;
                _this.setState({
                    loadedIcon: {
                        id: icon.id,
                        svgString: svgString
                    }
                });
            }, function (err) {
                err.message = err.message || '';
                err.message += " Error getting icon from \"" + icon.url + "\". Is source website down?";
                console.error(err);
            });
        }
    };
    Node.prototype.render = function () {
        var _this = this;
        var _a = this.props, borderWidth = _a.borderWidth, color = _a.color, filter = _a.filter, height = _a.height, id = _a.id, width = _a.width, children = _a.children, backgroundColor = _a.backgroundColor;
        var loadedIcon = this.state.loadedIcon;
        // Add the style too. Fixes firefox bug where fill, stroke etc. isn't inherited
        var style = {
            fill: backgroundColor,
            color: color,
            stroke: color,
            strokeWidth: borderWidth
        };
        return (React.createElement("g", { ref: function (containerRef) { return _this.containerRef = containerRef; } },
            React.createElement("g", { dangerouslySetInnerHTML: loadedIcon ? { __html: loadedIcon.svgString } : null }),
            React.createElement("use", { id: "icon-for-" + id, key: "icon-for-" + id, x: "0", y: "0", width: width + 'px', height: height + 'px', style: style, fill: backgroundColor, xlinkHref: loadedIcon ? '#' + loadedIcon.id : null, filter: !!filter ? "url(#" + filter + ")" : null, stroke: color, strokeWidth: borderWidth, className: "Icon" }),
            children));
    };
    return Node;
}(React.Component));
exports.Node = Node;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/Kaavio/components/Node.js
// module id = 260
// module chunks = 0